import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { approveDecoupledFlow } from '../actions';
import { checkConsentStatus } from '../actions';
import { useCloseBrowserApi } from '../helpers/useCloseBrowserApi';

const ConsentDecoupledPending = (props) => {
  const dispatch = useDispatch();
  useCloseBrowserApi(props.consent_guid);

  useEffect(() => {
    const timer = setTimeout(async () => {
      if (props.institution?.slug === 'pn_model_bank') {
        // For pn_model_bank: approve first, then check status
        if (props.consent_guid && props.institution?.slug) {
          try {
            await dispatch(approveDecoupledFlow(props.consent_guid, props.institution));
            // After approval response, check consent status without loader
            dispatch(checkConsentStatus(props.consent_guid, props.institution, Date.now(), false));
          } catch (error) {
            console.error('Error approving decoupled flow:', error);
            // If approval fails, still try to check status without loader
            dispatch(checkConsentStatus(props.consent_guid, props.institution, Date.now(), false));
          }
        }
      } else {
        dispatch(checkConsentStatus(props.consent_guid, props.institution, Date.now(), false));
      }
    }, 10000);

    return () => clearTimeout(timer);
  }, [dispatch, props.institution, props.consent_guid]);

  return (
    <>
      <div className="step-content">
        <div id="intro">
          <div className="consent-data-wrapper">
            <div className="formMain">
              <h2 className="sub-heading">Connecting to your bank&hellip;</h2>
              <p className="decoupled-pending-subtitle">
                We are trying to connect to <strong>{props.institution?.name || 'your bank'}</strong>. You will soon receive a notification from your bank.
              </p>

              <div className="decoupled-pending-card">
                <div className="decoupled-pending-card-header">
                  <h3>What to do next</h3>
                </div>
                <div className="decoupled-pending-card-body">
                  <ol className="decoupled-pending-steps">
                    <li>Keep this browser window open so that the flow will continue once the consent has been authorized on the mobile app</li>
                    <li>Open your bank&rsquo;s mobile app when you receive the notification</li>
                    <li>Review the consent details in the app</li>
                    <li>Approve the consent to proceed</li>
                  </ol>
                  <p class="" style={{ fontSize: '14px', margin: '5px 0' }}>If you have not enabled notifications in the bank's mobile app then you might not receive the notification. </p>
                  <p class="mobile-flow-warning" style={{ fontSize: '14px', backgroundColor: '#fff3cd', padding: '5px' }}>If you don't receive notification, go to Menu → Settings → Connections in the Bank's mobile app and look for the pending consent request. You could review and approve the consent directly from the app.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .decoupled-pending-subtitle {
          text-align: center;
          margin-bottom: 24px;
          font-size: 15px;
          color: #333;
        }
        .decoupled-pending-card {
          background: rgba(255, 255, 255, 0.5);
          border: 1px solid #cccccc;
          border-radius: 6px;
          margin-bottom: 24px;
          overflow: hidden;
        }
        .decoupled-pending-card-header {
          background-color: rgba(195, 195, 195, 0.3);
          padding: 12px 16px 8px;
        }
        .decoupled-pending-card-header h3 {
          margin: 0 0 4px 0;
          font-size: 16px;
        }
        .decoupled-pending-card-body {
          padding: 12px 16px 16px;
        }
        .decoupled-pending-steps {
          margin: 0;
          padding-left: 20px;
        }
        .decoupled-pending-steps li {
          margin-bottom: 8px;
          font-size: 14px;
        }
      `}</style>
    </>
  );
};

export default ConsentDecoupledPending;